import { inject, Injectable } from '@angular/core';
import { EventEntity, Pagination, UserContentEventList, UserEntity } from '@core/entities';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { GetUserId } from '@core/utils';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  userId: number = GetUserId();
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.apiUrl;

  getContentEvents(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<UserContentEventList> {
    return this._http.get<any>(`${this._apiUrl}/getOwnerEvents/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  getDashboardEvents(): Observable<EventEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/approvedClubEvents/user/${this.userId}`);
  }

  getAllEvents(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/approvedEvents/user/${this.userId}`);
  }

  getAEvent(id: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/get-event-by-id/${id}`).pipe(map((res) => res.result[0]));
  }

  getTeamMembers(teamId: number): Observable<UserEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/teamUsers/team/${teamId}`);
  }

  getOpenEvents(): Observable<UserContentEventList> {
    return this._http.get<any>(`${this._apiUrl}/openevents`);
  }

  create(formData: FormData): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createEvent`, formData);
  }

  update(id: number, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/event/${id}`, formData);
  }

  hideEventSeries(data: any): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/hideEventSeries`, data);
  }

  hiddenEventsList(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/listAllHideEvents/${this.userId}`);
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/event/${id}`);
  }

  deleteFile(id: number): Observable<any> {
    return this._http.get(`${this._apiUrl}/delete-image/event/${id}?attachment=document`);
  }

  markAsRead() {
    return this._http.get(`${this._apiUrl}/mark-as-read/events`);
  }

  downloadDocument(data: any): Observable<any> {
    return this._http.post(`${this._apiUrl}/download-document`, data, { responseType: 'blob' });
  }

  leaveEvent(eventId: number, userId: number, body: any): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/leaveEvent/user/${userId}/event_id/${eventId}`, body);
  }
}
